<template>
  <fieldset class="tab tab-18 none-bg">
    <div class="heading-form a-center">
      <span class="number">18/18</span>
      <p class="c-yellow">สุขภาพทางใจ</p>
      <h2 class="heading-h2 c-white">
        เดือนที่ผ่านมา หากคุณมีปัญหาหนักใจ คุณคิดว่า<span class="br767"
          >จะแก้ไขได้หรือไม่</span
        >
      </h2>
    </div>
    <div class="icw-fieldset-inner">
      <ul class="icw-fields">
        <li class="icw-field icw-field-full">
          <div class="icw-input icw-input-checkbox" id="rdoFixProblem">
            <div class="checkbox checkbox-default">
              <input
                type="radio"
                name="radio18"
                id="everytime4"
                class="css-checkbox"
                value="-1"
                v-model="resolve"
              />
              <label for="everytime4" class="css-label"
                >ไม่สามารถแก้ไขได้</label
              >
            </div>
            <div class="checkbox checkbox-default">
              <input
                type="radio"
                name="radio18"
                id="sometimes4"
                class="css-checkbox"
                value="sometime"
                v-model="resolve"
              />
              <label for="sometimes4" class="css-label">แก้ไขได้บางครั้ง</label>
            </div>
            <div class="checkbox checkbox-default">
              <input
                type="radio"
                name="radio18"
                id="notime5"
                class="css-checkbox"
                value="noproblem"
                v-model="resolve"
              />
              <label for="notime5" class="css-label">ทุกปัญหาแก้ไขได้</label>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div v-if="!isProcess" class="icw-fieldset-action previous">
      <button
        type="button"
        class="btn btn-previous previous"
        @click="prevStep('tab-18', 'tab-17')"
      >
        ย้อนกลับ
      </button>
    </div>
    <button
      id="btnNextStep"
      type="button"
      v-if="!isProcess"
      class="btn btn-next next btn-send"
      :class="{ 'btn-disabled': !isPass }"
      @click="beforeNextStep()"
    >
      ส่งแบบประเมิน
    </button>
  </fieldset>
</template>

<script>
import Vue from "vue";
import jQuery from "jquery";

import MyConfig from "@/../me.config.js";

import { my_storage } from "@/helpers/global_helper.js";
import { nextStep, prevStep } from "@/helpers/step_helper.js";

import axios from "axios";
import VueAxios from "vue-axios";

window.jQuery = window.$ = jQuery;

Vue.use(VueAxios, axios);

export default {
  name: "QuestionStep3_Q18",
  props: {
    QuestionType: String,
  },
  data() {
    return {
      isProcess: false,
      resolve: "",
      isSalecode: "",
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.setSalecode();
      this.resolve = my_storage(this.QuestionType, "Resolve");
    });
  },
  computed: {
    isPass() {
      return this.resolve != "";
    },
  },
  methods: {
    my_storage,
    nextStep,
    prevStep,
    setSalecode() {
      if (sessionStorage.getItem("salecode_button") == "1") {
        this.isSalecode = false;
      } else {
        this.isSalecode = false;
      }
    },
    beforeNextStep() {
      let self = this;
      let data = {
        isProcess: this.isProcess,
        resolve: this.resolve,
      };
      if (this.resolve != "") {
        // sessionStorage.setItem(this.QuestionType, JSON.stringify(this._data))
        sessionStorage.setItem(this.QuestionType, JSON.stringify(data));

        self.isProcess = true;

        /* Step 1 */
        let _information = JSON.parse(sessionStorage.getItem("Information"));
        let _job = JSON.parse(sessionStorage.getItem("Job"));
        let _contact = JSON.parse(sessionStorage.getItem("Contact"));
        let _profile = JSON.parse(sessionStorage.getItem("Profile"));
        let _income = JSON.parse(sessionStorage.getItem("Income"));
        let _lifestyle = JSON.parse(sessionStorage.getItem("LifeStyle"));
        let _healthy = JSON.parse(sessionStorage.getItem("Healthy"));
        let _lifestyle_gadget = JSON.parse(
          sessionStorage.getItem("LifestyleGadget")
        );
        let _healthy_activities = JSON.parse(
          sessionStorage.getItem("HealthyActivities")
        );
        let _run_activities = JSON.parse(
          sessionStorage.getItem("RunActivities")
        );
        let _bike_activities = JSON.parse(
          sessionStorage.getItem("BikeActivities")
        );
        /* Step 1 */

        /* Step 2 */
        let _child_parent = JSON.parse(sessionStorage.getItem("ChildParent"));
        let _expenses = JSON.parse(sessionStorage.getItem("Expenses"));
        let _money_health_1 = JSON.parse(
          sessionStorage.getItem("MoneyHealth1")
        );
        let _money_health_2 = JSON.parse(
          sessionStorage.getItem("MoneyHealth2")
        );
        let _money_health_3 = JSON.parse(
          sessionStorage.getItem("MoneyHealth3")
        );
        let _money_health_4 = JSON.parse(
          sessionStorage.getItem("MoneyHealth4")
        );
        let _money_health_5 = JSON.parse(
          sessionStorage.getItem("MoneyHealth5")
        );
        let _money_health_6 = JSON.parse(
          sessionStorage.getItem("MoneyHealth6")
        );
        let _money_health_7 = JSON.parse(
          sessionStorage.getItem("MoneyHealth7")
        );
        let _money_health_8 = JSON.parse(
          sessionStorage.getItem("MoneyHealth8")
        );
        /* Step 2 */

        /* Step 3 */
        let _health_info = JSON.parse(sessionStorage.getItem("HealthInfo"));
        let _workout_rate = JSON.parse(sessionStorage.getItem("WorkoutRate"));
        let _workout_time = JSON.parse(sessionStorage.getItem("WorkoutTime"));
        let _relax_time = JSON.parse(sessionStorage.getItem("RelaxTime"));
        let _wakeup_freq = JSON.parse(sessionStorage.getItem("WakeupFreq"));
        let _ride_freq = JSON.parse(sessionStorage.getItem("RideFreq"));
        let _hangout_freq = JSON.parse(sessionStorage.getItem("HangoutFreq"));
        let _use_mobile_phone = JSON.parse(
          sessionStorage.getItem("UseMobilePhone")
        );
        let _cigarette = JSON.parse(sessionStorage.getItem("Cigarrete"));
        let _cancer = JSON.parse(sessionStorage.getItem("Cancer"));
        let _eat_hotdog = JSON.parse(sessionStorage.getItem("EatHotdog"));
        let _milk_tea = JSON.parse(sessionStorage.getItem("MilkTea"));
        let _fried = JSON.parse(sessionStorage.getItem("Fried"));
        let _noodle = JSON.parse(sessionStorage.getItem("Noodle"));
        let _bored = JSON.parse(sessionStorage.getItem("Bored"));
        let _dismal = JSON.parse(sessionStorage.getItem("Dismal"));
        let _not_focus = JSON.parse(sessionStorage.getItem("NotFocus"));
        let _resolve = JSON.parse(sessionStorage.getItem("Resolve"));
        let _campaign_type = sessionStorage.getItem("is_campaign_type");
        /* Step 3 */

        let api_url = MyConfig.API_PATH;

        this.axios
          .post(
            api_url + "/api/save_data/" + localStorage.getItem("uuid"),
            $.param({
              _campaign:
                typeof window._site_params !== "undefined"
                  ? window._site_params.campaign
                  : "",
              _information: _information,
              _job: _job,
              _contact: _contact,
              _profile: _profile,
              _income: _income,
              _lifestyle: _lifestyle,
              _healthy: _healthy,
              _lifestyle_gadget: _lifestyle_gadget,
              _healthy_activities: _healthy_activities,
              _run_activities: _run_activities,
              _bike_activities: _bike_activities,

              _child_parent: _child_parent,
              _expenses: _expenses,
              _money_health_1: _money_health_1,
              _money_health_2: _money_health_2,
              _money_health_3: _money_health_3,
              _money_health_4: _money_health_4,
              _money_health_5: _money_health_5,
              _money_health_6: _money_health_6,
              _money_health_7: _money_health_7,
              _money_health_8: _money_health_8,

              _health_info: _health_info,
              _workout_rate: _workout_rate,
              _workout_time: _workout_time,
              _relax_time: _relax_time,
              _wakeup_freq: _wakeup_freq,
              _ride_freq: _ride_freq,
              _hangout_freq: _hangout_freq,
              _use_mobile_phone: _use_mobile_phone,
              _cigarette: _cigarette,
              _cancer: _cancer,
              _eat_hotdog: _eat_hotdog,
              _milk_tea: _milk_tea,
              _fried: _fried,
              _noodle: _noodle,
              _bored: _bored,
              _dismal: _dismal,
              _not_focus: _not_focus,
              _resolve: _resolve,
              _campaign_type: _campaign_type,
            }),
            {
              headers: { "Content-Type": "application/x-www-form-urlencoded" },
            }
          )
          .then(function(resp) {
            self.isProcess = false;

            if (resp.data.response == "success") {
              sessionStorage.setItem(
                "question_result",
                JSON.stringify({
                  code: resp.data.code,
                  firstname: _information.firstname,
                  lastname: _information.lastname,
                  token: resp.data.token,
                })
              );

              let _campaignPath = sessionStorage.getItem("_campaignPath");

              if (_campaignPath.includes(MyConfig.campaignWh)) {
                self.clearSessionData();
                self.callGoodWealthAndHealth(
                  resp,
                  _information,
                  _profile,
                  _contact,
                  _campaignPath
                );
              } else {
                self.clearSessionData();
                window.location.href = MyConfig.ResultPath;
              }
            } else {
              alert("กรุณาลองใหม่อีกครั้ง หรือติดต่อผู้ดูแลระบบ");
            }
          });

        this.isProcess = self.isProcess;
      } else if (this.resolve != "") {
        // sessionStorage.setItem(this.QuestionType, JSON.stringify(this._data))
        this.isProcess = true;
        sessionStorage.setItem(this.QuestionType, JSON.stringify(data));
        window.location.href = MyConfig.ResultPath;
      }
    },
    async callGoodWealthAndHealth(
      resp,
      _information,
      _profile,
      _contact,
      _campaignCode
    ) {
      const url = MyConfig.REST_PATH.whDataUrl;
      const objRequest = {
        cusId: resp.data.code.id,
        cusName: _information.firstname + " " + _information.lastname,
        cusTel: _contact.phone,
        houseNumber: _profile.addr_no,
        building: _profile.addr_building,
        villageNumber: _profile.addr_moo,
        alley: _profile.addr_soi,
        subDistrict: _profile.addr_subdistrict,
        district: _profile.addr_district,
        province: _profile.addr_province,
        zipCode: _profile.addr_zipcode,
        campaignCode: _campaignCode,
      };
      await this.axios
        .post(url, $.param(objRequest), {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        })
        .then((resp) => {
          let responseHtml = resp.data;
          window.location.href =
            MyConfig.REST_PATH.mainWH + "?cid=" + responseHtml;
        })
        .catch((err) => {
          console.error("ERROR: ", err);
          alert("กรุณาลองใหม่อีกครั้ง หรือติดต่อผู้ดูแลระบบ");
        });
    },
    clearSessionData() {
      sessionStorage.removeItem("Information");
      sessionStorage.removeItem("Job");
      // sessionStorage.removeItem('Contact')
      sessionStorage.removeItem("Profile");
      sessionStorage.removeItem("Income");
      sessionStorage.removeItem("LifeStyle");
      sessionStorage.removeItem("Healthy");
      sessionStorage.removeItem("LifestyleGadget");
      sessionStorage.removeItem("HealthyActivities");
      sessionStorage.removeItem("RunActivities");
      sessionStorage.removeItem("BikeActivities");

      sessionStorage.removeItem("ChildParent");
      sessionStorage.removeItem("Expenses");
      sessionStorage.removeItem("MoneyHealth1");
      sessionStorage.removeItem("MoneyHealth2");
      sessionStorage.removeItem("MoneyHealth3");
      sessionStorage.removeItem("MoneyHealth4");
      sessionStorage.removeItem("MoneyHealth5");
      sessionStorage.removeItem("MoneyHealth6");
      sessionStorage.removeItem("MoneyHealth7");
      sessionStorage.removeItem("MoneyHealth8");

      sessionStorage.removeItem("HealthInfo");
      sessionStorage.removeItem("WorkoutRate");
      sessionStorage.removeItem("WorkoutTime");
      sessionStorage.removeItem("RelaxTime");
      sessionStorage.removeItem("WakeupFreq");
      sessionStorage.removeItem("RideFreq");
      sessionStorage.removeItem("HangoutFreq");
      sessionStorage.removeItem("UseMobilePhone");
      sessionStorage.removeItem("Cigarrete");
      sessionStorage.removeItem("Cancer");
      sessionStorage.removeItem("EatHotdog");
      sessionStorage.removeItem("MilkTea");
      sessionStorage.removeItem("Fried");
      sessionStorage.removeItem("Noodle");
      sessionStorage.removeItem("Bored");
      sessionStorage.removeItem("Dismal");
      sessionStorage.removeItem("NotFocus");
      sessionStorage.removeItem("Resolve");

      sessionStorage.removeItem("step1");
      sessionStorage.removeItem("step2");
      sessionStorage.removeItem("step3");
      sessionStorage.removeItem("skipQuize10");
      sessionStorage.removeItem("phone");
      sessionStorage.removeItem("is_campaign_type");
      localStorage.removeItem("tls_consent_accept");
    },
  },
};
</script>
